import { ReactNode, useMemo } from 'react'
import { MainNavigation as BaseNavigation } from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'
import useEntityImpersonation from '@hooks/useEntityImpersonation'
import useLoginAsUser from '@hooks/useLoginAsUser'
import useMainNavigation from '@hooks/useMainNavigation'

import systemBrandPayload from '@components/systemBrands/default'
import generateMainNavigationItems from '@sections/Admin/utils/generateMainNavigationItems'

interface MainNavigationProps {
  minimized?: boolean,
  nestedNavigation?: ReactNode,
}

const MainNavigation = (props: MainNavigationProps) => {
  const { minimized, nestedNavigation } = props

  const currentUserPayload = useCurrentUser()
  const { currentUser, isBrandUser } = currentUserPayload

  // @ts-expect-error TS2345
  const entityImpersonationPayload = useEntityImpersonation(currentUser)
  const { callbacks: { unlinkImpersonation } } = entityImpersonationPayload

  const templateRedirect = isBrandUser ? '/admin/brandhub#/templates' : '/admin/templates/manage#/'
  const { callbacks: { loginAsUser } } = useLoginAsUser({ redirect: templateRedirect })

  const linkToTemplates = () => loginAsUser()

  const navigationItems = useMemo(() => (
    generateMainNavigationItems({
      callbacks: {
        linkToTemplates,
        unlinkImpersonation,
      },
      currentUserPayload,
    })
  ), [currentUser.id])

  const { callbacks: { toggleNavigation }, showNavigation } = useMainNavigation()

  return (
    <BaseNavigation
      callbacks={{
        // @ts-expect-error TS2322
        toggleSidebar: toggleNavigation,
      }}
      minimized={!!minimized}
      // @ts-expect-error TS2322
      navigationItems={navigationItems}
      nestedNavigation={nestedNavigation}
      nestedNavigationWidth={240}
      showNavigation={showNavigation}
      // @ts-expect-error TS2322
      systemBrandPayload={systemBrandPayload}
      width={220}
    />
  )
}

export default MainNavigation
